"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const icons_1 = require("@material-ui/icons");
const core_1 = require("@material-ui/core");
const UserMenu = (props) => {
    const [anchorEl, setAnchorEl] = react_1.useState(null);
    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Button, { color: "inherit", "data-testid": "usermenu-button", id: "usermenu-button", onClick: handleMenu, startIcon: react_1.default.createElement(icons_1.AccountCircle, null) },
            props.title,
            " ",
            react_1.default.createElement(icons_1.KeyboardArrowDown, null)),
        react_1.default.createElement(core_1.Menu, { anchorEl: anchorEl, anchorOrigin: {
                vertical: "top",
                horizontal: "right",
            }, "data-testid": "usermenu-menu", id: "usermenu-menu", keepMounted: true, onClose: handleClose, open: Boolean(anchorEl), transformOrigin: {
                vertical: "top",
                horizontal: "right",
            } },
            react_1.default.createElement(core_1.MenuItem, { "data-testid": "usermenu-menu-signout-item", id: "usermenu-menu-signout-item", onClick: props.onSignOut }, "Sign Out"))));
};
exports.default = UserMenu;
//# sourceMappingURL=index.js.map